import { render, staticRenderFns } from "./ProductSpecification.vue?vue&type=template&id=8809f4ea"
import script from "./ProductSpecification.vue?vue&type=script&lang=js"
export * from "./ProductSpecification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports